const $ = require('jquery');

const dismiss = function(element) {
	const targetSelector = $(element).data('target-selector');
	$(targetSelector).remove();
};

module.exports = dismiss;
